module.exports = __webpack_public_path__ + "static/media/month_06.7bf47928.png";